<template>
  <div class="dashboard-container">
    <div class="container" :class="{ hContainer: tableData.length }">
      <!-- 搜索项 -->
      <div class="tableBar">
        <label style="margin-right: 10px">申请编号：</label>
        <el-input
          v-model="searchForm.requestNumber"
          placeholder="请填写申请编号"
          style="width: 15%"
          clearable
          @clear="init"
          @keyup.enter.native="init"
        />

        <label style="margin-left: 20px">打手姓名：</label>
        <el-input
          v-model="searchForm.goonsName"
          placeholder="请填写打手姓名"
          style="width: 15%"
          clearable
          @clear="init"
          @keyup.enter.native="init"
        />

        <label style="margin-left: 20px">申请状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="请选择状态"
          clearable
          style="width: 120px"
          @change="init"
        >
          <el-option label="待审核" :value="0" />
          <el-option label="已通过" :value="1" />
          <el-option label="已驳回" :value="2" />
          <el-option label="已打款" :value="3" />
        </el-select>

        <label style="margin-left: 20px">申请时间：</label>
        <el-date-picker
          v-model="searchForm.dateRange"
          clearable
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="date-picker"
          @change="init"
        />

        <el-button class="normal-btn continue" @click="init">
          查询
        </el-button>
      </div>

      <!-- 统计信息 -->
      <div class="stats-container" v-if="statistics">
        <div class="stat-item">
          <div class="stat-number">{{ statistics.pendingCount }}</div>
          <div class="stat-label">待审核</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">{{ statistics.approvedCount }}</div>
          <div class="stat-label">已通过</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">{{ statistics.rejectedCount }}</div>
          <div class="stat-label">已驳回</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">{{ statistics.paidCount }}</div>
          <div class="stat-label">已打款</div>
        </div>
      </div>

      <!-- 表格 -->
      <el-table
        v-if="tableData.length"
        :data="tableData"
        stripe
        class="tableBox"
      >
        <el-table-column prop="requestNumber" label="申请编号" min-width="150" />
        <el-table-column prop="goonsName" label="打手姓名" />
        <el-table-column prop="realName" label="真实姓名" />
        <el-table-column prop="phone" label="手机号" />
        <el-table-column prop="amount" label="申请金额" align="right">
          <template slot-scope="{ row }">
            <span>￥{{ row.amount.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fee" label="手续费" align="right">
          <template slot-scope="{ row }">
            <span>￥{{ row.fee.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="actualAmount" label="实际到账" align="right">
          <template slot-scope="{ row }">
            <span>￥{{ row.actualAmount.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="paymentMethodName" label="支付方式" />
        <el-table-column prop="statusName" label="申请状态">
          <template slot-scope="{ row }">
            <el-tag
              :type="getStatusTagType(row.status)"
              size="small"
            >
              {{ row.statusName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="applyTime" label="申请时间" min-width="160" />
        <el-table-column prop="reviewerName" label="审核人" />
        <el-table-column prop="reviewTime" label="审核时间" min-width="160" />
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{ row }">
            <div class="action-buttons">
              <el-button
                v-if="row.status === 0"
                type="success"
                size="mini"
                @click="handleApprove(row)"
              >
                通过
              </el-button>
              <el-button
                v-if="row.status === 0"
                type="danger"
                size="mini"
                @click="handleReject(row)"
              >
                驳回
              </el-button>
              <el-button
                v-if="row.status === 1"
                type="primary"
                size="mini"
                @click="handleConfirmPayment(row)"
              >
                确认打款
              </el-button>
              <el-button
                type="info"
                size="mini"
                @click="handleViewDetail(row)"
              >
                查看详情
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination" v-if="tableData.length">
        <el-pagination
          :current-page="pagination.current"
          :page-sizes="[10, 20, 50]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>

      <!-- 空状态 -->
      <div v-else class="empty-state">
        <el-empty description="暂无提现申请数据"></el-empty>
      </div>
    </div>

    <!-- 驳回原因对话框 -->
    <el-dialog
      title="驳回提现申请"
      :visible.sync="rejectDialogVisible"
      width="500px"
    >
      <el-form :model="rejectForm" :rules="rejectRules" ref="rejectForm">
        <el-form-item label="驳回原因" prop="rejectReason">
          <el-input
            v-model="rejectForm.rejectReason"
            type="textarea"
            :rows="4"
            placeholder="请填写驳回原因"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmReject">确定</el-button>
      </div>
    </el-dialog>

    <!-- 详情对话框 -->
    <el-dialog
      title="提现申请详情"
      :visible.sync="detailDialogVisible"
      width="600px"
    >
      <div v-if="currentWithdraw" class="detail-content">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="申请编号">
            {{ currentWithdraw.requestNumber }}
          </el-descriptions-item>
          <el-descriptions-item label="申请状态">
            <el-tag :type="getStatusTagType(currentWithdraw.status)">
              {{ currentWithdraw.statusName }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="打手姓名">
            {{ currentWithdraw.goonsName }}
          </el-descriptions-item>
          <el-descriptions-item label="真实姓名">
            {{ currentWithdraw.realName }}
          </el-descriptions-item>
          <el-descriptions-item label="手机号">
            {{ currentWithdraw.phone }}
          </el-descriptions-item>
          <el-descriptions-item label="支付方式">
            {{ currentWithdraw.paymentMethodName }}
          </el-descriptions-item>
          <el-descriptions-item label="申请金额">
            ￥{{ currentWithdraw.amount.toFixed(2) }}
          </el-descriptions-item>
          <el-descriptions-item label="手续费">
            ￥{{ currentWithdraw.fee.toFixed(2) }}
          </el-descriptions-item>
          <el-descriptions-item label="实际到账">
            ￥{{ currentWithdraw.actualAmount.toFixed(2) }}
          </el-descriptions-item>
          <el-descriptions-item label="手续费率">
            {{ (currentWithdraw.feeRate * 100).toFixed(2) }}%
          </el-descriptions-item>
          <el-descriptions-item label="申请时间">
            {{ currentWithdraw.applyTime }}
          </el-descriptions-item>
          <el-descriptions-item label="审核时间" v-if="currentWithdraw.reviewTime">
            {{ currentWithdraw.reviewTime }}
          </el-descriptions-item>
          <el-descriptions-item label="审核人" v-if="currentWithdraw.reviewerName">
            {{ currentWithdraw.reviewerName }}
          </el-descriptions-item>
          <el-descriptions-item label="打款时间" v-if="currentWithdraw.paymentTime">
            {{ currentWithdraw.paymentTime }}
          </el-descriptions-item>
          <el-descriptions-item label="驳回原因" v-if="currentWithdraw.rejectReason" :span="2">
            {{ currentWithdraw.rejectReason }}
          </el-descriptions-item>
          <el-descriptions-item label="备注" v-if="currentWithdraw.remark" :span="2">
            {{ currentWithdraw.remark }}
          </el-descriptions-item>
        </el-descriptions>

        <!-- 收款码显示 -->
        <div class="payment-code-section" v-if="currentWithdraw.alipayCode || currentWithdraw.wechatCode">
          <h4>收款码</h4>
          <div class="code-images">
            <div v-if="currentWithdraw.alipayCode" class="code-item">
              <p>支付宝收款码</p>
              <img :src="currentWithdraw.alipayCode" alt="支付宝收款码" class="payment-code-image" />
            </div>
            <div v-if="currentWithdraw.wechatCode" class="code-item">
              <p>微信收款码</p>
              <img :src="currentWithdraw.wechatCode" alt="微信收款码" class="payment-code-image" />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getWithdrawRequestPage,
  getWithdrawRequestDetail,
  reviewWithdrawRequest,
  confirmWithdrawPayment,
  getWithdrawRequestStatistics
} from '@/api/order'

export default {
  name: 'WithdrawManagement',
  data() {
    return {
      tableData: [],
      statistics: null,
      searchForm: {
        requestNumber: '',
        goonsName: '',
        status: null,
        dateRange: []
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      rejectDialogVisible: false,
      detailDialogVisible: false,
      currentWithdraw: null,
      rejectForm: {
        rejectReason: ''
      },
      rejectRules: {
        rejectReason: [
          { required: true, message: '请填写驳回原因', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.init()
    this.loadStatistics()
  },
  methods: {
    // 初始化数据
    async init() {
      try {
        const params = {
          page: this.pagination.current,
          pageSize: this.pagination.size,
          ...this.searchForm
        }

        // 处理日期范围
        if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
          params.beginTime = this.searchForm.dateRange[0]
          params.endTime = this.searchForm.dateRange[1]
        }

        const response = await getWithdrawRequestPage(params)
        if (response.data.code === 1 && response.data.data) {
          this.tableData = response.data.data.records || []
          this.pagination.total = response.data.data.total || 0
        } else {
          this.tableData = []
          this.pagination.total = 0
        }
      } catch (error) {
        console.error('获取提现申请列表失败:', error)
        this.$message.error('获取数据失败')
      }
    },

    // 加载统计信息
    async loadStatistics() {
      try {
        const response = await getWithdrawRequestStatistics()
        if (response.data.code === 1 && response.data.data) {
          this.statistics = response.data.data
        }
      } catch (error) {
        console.error('获取统计信息失败:', error)
      }
    },

    // 审核通过
    async handleApprove(row) {
      try {
        await this.$confirm('确定通过此提现申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        })

        const reviewData = {
          id: row.id,
          status: 1 // 通过
        }

        await reviewWithdrawRequest(reviewData)
        this.$message.success('审核通过成功')
        this.init()
        this.loadStatistics()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('审核通过失败:', error)
          this.$message.error('审核失败')
        }
      }
    },

    // 驳回申请
    handleReject(row) {
      this.currentWithdraw = row
      this.rejectForm.rejectReason = ''
      this.rejectDialogVisible = true
    },

    // 确认驳回
    async confirmReject() {
      try {
        await this.$refs.rejectForm.validate()

        const reviewData = {
          id: this.currentWithdraw.id,
          status: 2, // 驳回
          rejectReason: this.rejectForm.rejectReason
        }

        await reviewWithdrawRequest(reviewData)
        this.$message.success('驳回成功')
        this.rejectDialogVisible = false
        this.init()
        this.loadStatistics()
      } catch (error) {
        console.error('驳回失败:', error)
      }
    },

    // 确认打款
    async handleConfirmPayment(row) {
      try {
        await this.$confirm('确定已完成打款吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        await confirmWithdrawPayment(row.id)
        this.$message.success('确认打款成功')
        this.init()
        this.loadStatistics()
      } catch (error) {
        if (error !== 'cancel') {
          console.error('确认打款失败:', error)
          this.$message.error('确认打款失败')
        }
      }
    },

    // 查看详情
    async handleViewDetail(row) {
      try {
        const response = await getWithdrawRequestDetail(row.id)
        if (response.data.code === 1 && response.data.data) {
          this.currentWithdraw = response.data.data
          this.detailDialogVisible = true
        } else {
          this.$message.error('获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        this.$message.error('获取详情失败')
      }
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.size = val
      this.pagination.current = 1
      this.init()
    },

    // 页码改变
    handleCurrentChange(val) {
      this.pagination.current = val
      this.init()
    },

    // 获取状态标签类型
    getStatusTagType(status) {
      switch (status) {
        case 0: return 'warning'
        case 1: return 'success'
        case 2: return 'danger'
        case 3: return 'info'
        default: return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  padding: 20px;
}

.container {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  min-height: 600px;
}

.tableBar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;

  label {
    font-weight: 500;
    color: #333;
  }

  .el-input {
    margin-right: 10px;
  }

  .date-picker {
    width: 300px;
    margin-left: 10px;
  }
}

.stats-container {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;

  .stat-item {
    text-align: center;

    .stat-number {
      font-size: 24px;
      font-weight: bold;
      color: #409eff;
      margin-bottom: 5px;
    }

    .stat-label {
      font-size: 14px;
      color: #666;
    }
  }
}

.tableBox {
  margin-bottom: 20px;
}

.pagination {
  text-align: right;
}

.empty-state {
  text-align: center;
  padding: 60px 0;
}

.detail-content {
  .payment-code-section {
    margin-top: 20px;

    h4 {
      margin-bottom: 15px;
      color: #333;
    }

    .code-images {
      display: flex;
      gap: 20px;

      .code-item {
        text-align: center;

        p {
          margin-bottom: 10px;
          font-weight: 500;
        }

        .payment-code-image {
          width: 150px;
          height: 150px;
          object-fit: contain;
          border: 1px solid #ddd;
          border-radius: 8px;
        }
      }
    }
  }
}

.dialog-footer {
  text-align: right;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  .el-button {
    flex: none;
    margin: 0 !important;
    padding: 7px 12px;
    box-sizing: border-box;
    white-space: nowrap;
  }

  .el-button--mini {
    padding: 7px 12px;
  }
}
</style>
